module.exports = __webpack_public_path__ + "media/bootstrap-icons/triangle-half-090d92fd.svg";